import {Injectable, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {UsersService} from './users.service';
import {EMPTY, from, Observable, of} from 'rxjs';
import {MatDialog} from "@angular/material/dialog";
import {KeycloakEventType, KeycloakService} from 'keycloak-angular';
import {filter, skipWhile, switchMap} from 'rxjs/operators';
import {AuthService} from "./auth.service";
import {User} from "../model/user";

@Injectable({
  providedIn: 'root',
})
export class KeycloakAuthService extends AuthService {

  // Static property to track if Keycloak is configured
  // private static readonly isUsingKeycloak = !!environment.keycloak;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private usersService: UsersService,
    private dialogService: MatDialog,
    private keycloak: KeycloakService
  ) {

    super();
    from(this.keycloak.isLoggedIn()).subscribe(isLogged => {
      if (isLogged) {
        this.fillInternalUser();
      }
    });

    this.keycloak.keycloakEvents$
      .pipe(filter(e => e.type === KeycloakEventType.OnAuthSuccess || e.type === KeycloakEventType.OnAuthLogout))
      .subscribe(e => {
        if (e.type === KeycloakEventType.OnAuthSuccess) {
          this.fillInternalUser();
        } else {
          this.flushState();
        }
      });
  }


  override getToken(): Observable<string> {
    return of(this.keycloak.getKeycloakInstance().token);
  }

  override onUserChange(): Observable<User | undefined> {
    return from(this.keycloak.isLoggedIn())
      .pipe(
        switchMap(isLoggedIn => {
          if (!isLoggedIn) {
            return of(undefined);
          }
          return this.behaviorUser.asObservable()
            .pipe(
              skipWhile(user => !user)
            );
        })
      );
  }

  override login(): void {
    from(this.keycloak.isLoggedIn())
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.router.navigate(['reserved']);
        } else {
          this.keycloak.login({redirectUri: window.location.origin + '/reserved'});
        }
      });
  }

  override logout(): void {
    this.flushState();
    this.keycloak.logout(window.location.origin);
  }

  override clearUser(): void {
    this.dialogService.closeAll();
    this.keycloak.logout(window.location.origin);
  }

  override refreshUser?(): void {
  }

  override changePassword(oldPassword: string, newPassword: string): Observable<any> {
    return this.usersService.updatePassword(newPassword);
  }

  private fillInternalUser(): void {
    const kInstance = this.keycloak.getKeycloakInstance();
    const tokenParsed: any = kInstance.tokenParsed;
    const keycloakUserId = tokenParsed?.sub;

    this.usersService.getUser(keycloakUserId).subscribe({
      next: user => {
        this._internalUser = user;
        this.behaviorUser.next(user);
      },
      error: () => {
        this.behaviorUser.next(undefined);
      }
    });
  }

  private flushState(): void {
    this._internalUser = undefined;
    this.behaviorUser.next(undefined);
  }
}
